<template>
  <div class="activeOption">
    <div class="title">{{ $t('home.qe') }}</div>
    <div class="content">
      <!-- 活动申请 -->
      <div class="col" v-if="$store.state.userInfo.userType === 'rj'">
        <div class="wrap" @click="pageJump('/activityApplication')">
          <img src="@/assets/images/activityApplicationIcon.png">
          <div>{{ $t('home.ea') }}</div>
        </div>
      </div>
      <!-- 快捷申请 -->
      <div class="col" v-if="$store.state.userInfo.userType === 'rj'">
        <div class="wrap" @click="pageJump('/quickApplicationForm')">
          <img src="@/assets/images/quickApplicationIcon.png">
          <div>{{ $t('home.qa') }}</div>
        </div>
      </div>
      <!-- 行业报备申请 -->
      <div class="col" v-if="$store.state.userInfo.userType === 'rj' && industryReportShow && lang === 'zh-CN' && !$store.state.useSimplifiedUI">
        <div class="wrap" @click="pageJump('/industryReportApplication')">
          <img src="@/assets/images/reportApplicationIcon.png">
          <div>{{ $t('home.industryReporting') }}</div>
        </div>
      </div>
      <!-- <div class="col" v-if="$store.state.userInfo.userType === 'rj' && regionalReportShow && lang === 'zh-CN'">
        <div class="wrap" @click="pageJump('/reportApplication')">
          <img src="@/assets/images/reportApplicationIcon.png">
          <div>{{ $t('home.aff') }}</div>
        </div>
      </div> -->
      <!-- 区域报备申请 -->
      <div class="col" v-if="$store.state.userInfo.userType === 'rj' && regionalReportShow && lang === 'zh-CN' && !$store.state.useSimplifiedUI">
        <div class="wrap" @click="pageJump('/regionReportApplication')">
          <img src="@/assets/images/reportApplicationIcon.png">
          <div>{{ $t('home.regionalReporting') }}</div>
        </div>
      </div>
      <!-- 渠道申请 -->
      <div class="col" v-if="$store.state.userInfo.userType === 'qd'">
        <div class="wrap" @click="pageJump('/qdApplication')">
          <img src="@/assets/images/qdApplicationIcon.png">
          <div>{{ $t('home.ca') }}</div>
        </div>
      </div>
      <!-- 活动查询 -->
      <div class="col">
        <div class="wrap" @click="pageJump('/activityQuery')">
          <img src="@/assets/images/activityQueryIcon.png">
          <div>{{ $t('home.ai') }}</div>
        </div>
      </div>
      <!-- 年度营销规划 -->
      <div class="col" v-if="$store.state.userInfo.userType === 'rj' && annualShow && lang === 'zh-CN' && !$store.state.useSimplifiedUI">
        <div class="wrap" @click="pageJump('/annualMarketingPlan')">
          <img src="@/assets/images/annualMarketingPlanIcon.png">
          <div>{{ $t('home.annualMarketingPlan') }}</div>
        </div>
      </div>
      <!-- 草稿箱 -->
      <div class="col">
        <div class="wrap" @click="pageJump('/drafts')">
          <img src="@/assets/images/draftsIcon.png">
          <div>{{ $t('home.db') }}</div>
        </div>
      </div>
      <!-- 参观预约 -->
      <div class="col">
        <div class="wrap" @click="toExperienceCenter()">
          <img src="@/assets/images/makeAppointmentIcon.png">
          <div>{{ $t('home.vr') }}</div>
        </div>
      </div>
      <!-- 帮助文档 -->
      <div class="col">
        <div class="wrap" @click="pageJump('/helpDocumentation')">
          <img src="@/assets/images/helpDocIcon.png">
          <div>{{ $t('home.hwd') }}</div>
        </div>
      </div>
      <!-- 渠道大会 -->
      <!-- <div v-if="$store.state.userInfo.userType === 'rj' && qdbmdhShow" class="col">
        <div class="wrap" @click="pageJump('/htDetails')">
          <img src="@/assets/images/htIcon.png">
          <div>{{ $t('home.qddhbm') }}</div>
        </div>
      </div> -->
      <!-- <div class="col">
        <div class="wrap" @click="historyBillJump()">
          <img src="@/assets/images/historyBillIcon.png">
          <div>{{$t('home.hd')}}</div>
        </div>
      </div> -->
      <!--      <div class="row">-->
      <!--        <div class="col" @click="pageJump('/newApplicationForm')">-->
      <!--          <div class="image">-->
      <!--            <img src="@/assets/images/iconNewApplication.png">-->
      <!--          </div>-->
      <!--          <span>新建申请</span>-->
      <!--        </div>-->
      <!--        <div class="col" @click="pageJump('/quickApplicationForm')" v-if="$store.state.userInfo.userType === 'rj'">-->
      <!--          <div class="image">-->
      <!--            <img src="@/assets/images/apply.png">-->
      <!--          </div>-->
      <!--          <span>快捷申请</span>-->
      <!--          &lt;!&ndash; <div class="bubbleBox" @click.stop="">-->
      <!--              <span>活动类型为其他类（资料申请、会费、案例集、样板包装等）可以使用快捷申请。</span>-->
      <!--              <div>-->
      <!--              &lt;!&ndash;<span @click.stop="bubbleBoxShow = false">我知道了</span>&ndash;&gt;-->
      <!--              </div>-->
      <!--            </div> &ndash;&gt;-->
      <!--        </div>-->
      <!--        <div class="col" @click="pageJump('/activityQuery')">-->
      <!--          <div class="image">-->
      <!--            <img src="@/assets/images/activityQuery.png">-->
      <!--          </div>-->
      <!--          <span>活动查询</span>-->
      <!--        </div>-->
      <!--        <div class="col" @click="pageJump('/drafts')">-->
      <!--          <div class="image">-->
      <!--            <img src="@/assets/images/drafts.png">-->
      <!--          </div>-->
      <!--          <span>草稿箱</span>-->
      <!--        </div>-->
      <!--        <div class="col" @click="toExperienceCenter()">-->
      <!--          <div class="image">-->
      <!--            <img src="@/assets/images/makeAppointment.png">-->
      <!--          </div>-->
      <!--          <span>参观预约</span>-->
      <!--        </div>-->
      <!--        <div class="col" @click="pageJump('/helpDocumentation')" v-if="$store.state.userInfo.userType !== 'rj'">-->
      <!--          <div class="image">-->
      <!--            <img src="@/assets/images/helpDocumentation.png">-->
      <!--          </div>-->
      <!--          <span>帮助文档</span>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="row">-->
      <!--        <div class="col" @click="pageJump('/helpDocumentation')" v-if="$store.state.userInfo.userType === 'rj'">-->
      <!--          <div class="image">-->
      <!--            <img src="@/assets/images/helpDocumentation.png">-->
      <!--          </div>-->
      <!--          <span>帮助文档</span>-->
      <!--        </div>-->
      <!--        <div class="col" @click="historyBillJump()" id="grid">-->
      <!--          <div class="image">-->
      <!--            <img src="@/assets/images/historyBill.png">-->
      <!--          </div>-->
      <!--          <span>历史单据</span>-->
      <!--        </div>-->
      <!--        <div class="col" />-->
      <!--        <div class="col" />-->
      <!--        <div class="col" />-->
      <!--      </div>-->
    </div>
    <!-- 汇总表 -->
    <div class="pageFooting" v-if="$store.state.userInfo.userType === 'rj' && regionalReportShow && lang === 'zh-CN' && !$store.state.useSimplifiedUI">
      <div class="col" @click="pageJump('/industryActivitySummary')">
        <img src="@/assets/images/industryActivitySummary.png">
        <span class="col-text">
          {{ $t('home.industryHeadReporting') }}
        </span>
      </div>
      <div class="col" @click="pageJump('/industryTemplateActivitySummary')">
        <img src="@/assets/images/industryTemplateActivitySummary.png">
        <span class="col-text">
          {{ $t('home.industryTemplateReporting') }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      bubbleBoxShow: true,
      regionalReportShow: false,
      industryReportShow: false,
      annualShow: false,
      lang: localStorage.getItem('lang') || 'zh-CN',
      quickShow: false,
      qdbmdhShow: false
    };
  },
  mounted () {
    let deptCode = this.$store.state.userInfo.sysUser.deptCode;
    const { admin } = this.$store.state.userInfo.permissionDTO;
    if (admin) {
      this.regionalReportShow = admin;
      this.annualShow = admin;
      this.quickShow = admin;
      this.industryReportShow = admin;
      this.qdbmdhShow = admin;
    } else if (deptCode) {
      // '品牌营销部 000013'
      // '中国南区平台管理部 000062730'
      // '中国北区平台管理部 000062692'

      // '政府系统部' 000062705
      // '智能建筑及ICT系统部' 000062703
      // '企业系统部' 000062698
      // '软件产品营销部' 000062732
      // '企业级AIGC及服务业系统部' 000062721
      // '交通系统部' 000062734
      // '教育系统部' 000062706
      // '金融系统部' 000062689
      // '服务业系统部' 000062733
      // '医疗系统部' 000062699
      // '渠道产品系统部' 000062702
      // '战略与流程管理' 000062724

      // 快捷申请入口
      // CBG 000087
      // TBU 000054
      // 战略合作部 000091
      // 大客户IMC组 000013108

      // 渠道大会
      // 'SBG亚太大区' 000063664
      // '品牌营销部' 000013
      // 'SBG全球市场中心' 000063663
      // '商务部' 000034
      // '国际运营管理部' 000105

      const REGIONAL_DEPT_SET = new Set(['000013', '000062730', '000062692', '000062705', '000062703', '000062698', '000062732', '000062721', '000062734', '000062706', '000062689', '000062733', '000062699', '000062702', '000062724']);
      const INDUSTRY_DEPT_SET = new Set(['000013', '000062705', '000062703', '000062698', '000062721', '000062734', '000062732', '000062706', '000062689', '000062733', '000062699', '000062702', '000062724']);
      const ANNUAL_DEPT_SET = new Set(['000013', '000062']);
      const QUICK_DEPT_SET = new Set(['000087', '000054', '000091', '000013108']);
      const QDBMDH_DEPT_SET = new Set(['000063664', '000013', '000063663', '000034', '000105']);
      this.industryReportShow = this.checkDeptCode(INDUSTRY_DEPT_SET); // 行业
      this.regionalReportShow = this.checkDeptCode(REGIONAL_DEPT_SET); // 区域
      this.annualShow = this.checkDeptCode(ANNUAL_DEPT_SET); // 年度
      this.quickShow = !this.checkDeptCode(QUICK_DEPT_SET); // 快捷
      this.qdbmdhShow = this.checkDeptCode(QDBMDH_DEPT_SET); // 渠道大会
    }
  },
  methods: {
    checkDeptCode (deptSet) {
      const deptCode = this.$store.state.userInfo.sysUser.deptCode;
      for (const dept of deptSet) {
        if (deptCode.indexOf(dept) === 0) {
          return true;
        }
      }
      return false;
    },
    pageJump (url) {
      this.$router.push(url);
    },
    toExperienceCenter () {
      if (this.$store.state.userInfo.userType === 'rj') {
        window.open('http://casecenter.ruijie.com.cn/');
      } else {
        window.open('http://experience.ruijie.com.cn/');
      }
    },
    historyBillJump () {
      window.open('http://mms2012.ruijie.com.cn');
    }
  }
};
</script>
<style lang="scss" scoped>
.activeOption {
  width: 50%;
  margin-right: 16px;
  background: #ffffff;
  // padding: 0 16px;
  >.title{
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    margin-top: 20px;
    padding: 0 16px;
  }
  >.content{
    display: flex;
    flex-wrap: wrap;
    padding: 0 16px;
    >.col{
      margin-top: 24px;
      width: calc(100%/5);
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      >.wrap{
        &:hover{
          cursor: pointer;
        }
        >img {
          width: 57px;
          @media screen and (max-width: 1240px) {
            width: 44px;
          }
        }
      }
    }
    //>.row{
    //  display: flex;
    //  justify-content: space-between;
    //  margin-top: 24px;
    //  >.col{
    //    width: 56px;
    //    text-align: center;
    //    position: relative;
    //    &:hover{
    //      cursor: pointer;
    //    }
    //    >.image{
    //      width: 56px;
    //      border-radius: 50%;
    //      display: flex;
    //      justify-content: center;
    //      align-items: center;
    //      margin: 0 auto 8px;
    //      @media screen and (max-width: 1240px) {
    //        max-width: 44px;
    //      }
    //      >img{
    //        width: 100%;
    //      }
    //    }
    //    &:hover >.bubbleBox{
    //      display: block;
    //    }
    //    >.bubbleBox{
    //      display: none;
    //      width: 370px;
    //      border-radius: 4px;
    //      box-shadow: 0px 0px 16px rgba(24, 64, 122, 0.24);
    //      background: #3384FE;
    //      position: absolute;
    //      left: 14px;
    //      top: 90px;
    //      color: #ffffff;
    //      text-align: left;
    //      padding: 16px 14px;
    //      line-height: 20px;
    //      z-index: 150;
    //      >div{
    //        margin-top: 14px;
    //        text-align: right;
    //        cursor: pointer;
    //      }
    //      &:after{
    //        content: '';
    //        display: block;
    //        position: absolute;
    //        left: 10px;
    //        top: -10px;
    //        width: 0;
    //        height: 0;
    //        border-left: 12px solid transparent;
    //        border-right: 12px solid transparent;
    //        border-bottom: 24px solid #3384FE;
    //      }
    //    }
    //  }
    //}
  }
  .pageFooting{
    border-top: 3px solid #f0f4f8;
    padding: 24px 16px;
    display: flex;
    flex-wrap: wrap;
    >.col{
      &:hover{
          cursor: pointer;
        }
      width: calc(100%/ 2.5);
      padding-left: calc((20% - 57px) / 2);
      display: flex;
      >img {
        width: 57px;
        height: 57px;
        @media screen and (max-width: 1240px) {
          padding-left: calc((20% - 44px) / 2);
          width: 44px;
          height: 44px;
        }
      }
      >.col-text{
      padding-left: 16px;
      padding-top: 15px;
       @media screen and (max-width: 1240px) {
        padding-top: 10px;
      }
    }
    }
  }
}
</style>
